import { combineReducers, Reducer } from 'redux';
import { IAppState } from '../IAppState';
import { searchReducer } from './search/search.reducer';
import { filterReducer } from './filter/filter.reducer';

export const rootReducer: Reducer<IAppState> = combineReducers({
    searchReducer,
    filterReducer
});
